export enum QuoteStatus {
  New = "New",
  QuoteAccepted = "QuoteAccepted",
  GoneToOrder = "GoneToOrder",
  Fitted = "Fitted",
  Dead = "Dead",
  Expired = "Expired",
  Cancelled = "Cancelled",
  Invoiced = "Invoiced",
}
